export default __webpack_public_path__ + "static/media/logo-complete.b57be345.png";